import { ApiPostRequest } from "./api-post-request";
import { ApiParameters } from "./api-parameters";
import { TrackingChannel } from "../../enums/tracking-channel";

export class CreateSmtOrderByOrderIdRequest extends ApiPostRequest
{
    public constructor( orderId: number, 
                        webapiBasepath: string,
                        referrer?: string, 
                        browser?: string, 
                        platform?: string, 
                        version?: string, 
                        trackingChannel?: TrackingChannel
    ) {

        super(  'order/createsmtorderbyorderid',
                new ApiParameters(),
                null,
                {
                    'orderId': orderId,
                    'referrer': referrer,
                    'browser': browser,
                    'platform': platform,
                    'version': version,
                    'trackingChannel': trackingChannel
                },
                webapiBasepath
            );
    }
}
